exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// /usr/src/sentry/node_modules/css-loader?{"minimize":true}!/usr/src/sentry/node_modules/less-loader/dist/cjs.js!./less/components/externalLink.less
// module id = 897
// module chunks = 74